// PatchFormContext.js
import React, { createContext, useState, useContext } from 'react';
import { useAuth } from 'oidc-react';
import { useTenantSelection } from '../TenantSelectionProvider';

export interface PatchFormData {
  TenantID: string;
  RemediationPlanData: object;
  RemediationPlanPatchList: object[];
  WindowsOSUpdateList: object[];
  MacOSUpdateList: object[];
  LinuxOSUpdateList: object[];
  osUpdateOperationType: 'Install' | 'Uninstall';
  osUpdateSource?: 'install' | 'uninstall';
}

interface PatchFormContextType {
  patchFormData: PatchFormData;
  setPatchFormData: React.Dispatch<React.SetStateAction<PatchFormData>>;
  resetPatchFormData: () => void;
}

const PatchFormContext = createContext<PatchFormContextType | undefined>(undefined);

export const PatchFormProvider = ({ children }) => {
  const { selectedTenantId } = useTenantSelection();

  const getInitialState = (): PatchFormData => ({
    TenantID: selectedTenantId as string,
    RemediationPlanData: {
      PlanName: '',
      IsEmergencyRemediationPlan: false,
      SendEmailOnCompletion: true,
      RemediationPlanStartTime: '',
      IsActive: true,
    },
    RemediationPlanPatchList: [],
    WindowsOSUpdateList: [],
    MacOSUpdateList: [],
    LinuxOSUpdateList: [],
    osUpdateOperationType: 'Install',
    osUpdateSource: 'install',
  });

  const [patchFormData, setPatchFormData] = useState<PatchFormData>(getInitialState());

  const resetPatchFormData = () => {
    setPatchFormData(getInitialState());
  };

  return <PatchFormContext.Provider value={{ patchFormData, setPatchFormData, resetPatchFormData }}>{children}</PatchFormContext.Provider>;
};

export const usePatchForm = () => useContext(PatchFormContext);
